import { Box, Stack } from "@mui/material";
import { dashboardLayoutStyles } from "./dashboardLayout.styles";
import { DashboardTopbar } from "./DashboardTopbar";
import { FilterOption, SortOption, ViewMode } from "../types/dashboard.types";
import { colors } from "../../../ui/colors";

interface NavItem {
  id: string;
  label: string;
  icon: React.ReactNode;
  active?: boolean;
  onClick: () => void;
}

interface UserProfile {
  name: string;
  email?: string;
  plan?: string;
  avatar?: string;
}

interface DashboardLayoutProps {
  children: React.ReactNode;
  userProfile?: UserProfile;
  // Topbar props
  searchQuery: string;
  onSearchChange: (query: string) => void;
  filterStatus: FilterOption;
  onFilterChange: (filter: FilterOption) => void;
  sortBy: SortOption;
  onSortChange: (sort: SortOption) => void;
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
  onThemeToggle?: () => void;
}

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  children,
  userProfile,
  searchQuery,
  onSearchChange,
  filterStatus,
  onFilterChange,
  sortBy,
  onSortChange,
  viewMode,
  onViewModeChange,
  onThemeToggle,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        height: "88vh",
        py: 2,
        px: 4,
        border: `1px solid ${colors.gray[100]}`,
        boxShadow: "0 8px 4px -2px rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.06)",
        borderRadius: "16px",
        background: "var(--fx-surface-base, #FFFFFF)",
        transition: "0.2s all ease-in",

        mr: 4,
        ml: 1,
        backgroundColor: "var(--fx-surface-base, #FFFFFF)",
      }}
    >
      {/* Sidebar */}
      {/* <DashboardSidebar
        onNewSite={onNewSite}
        navItems={navItems}
        userProfile={userProfile}
      /> */}

      {/* Main Content */}
      <Box sx={dashboardLayoutStyles.mainContent}>
        {/* Topbar */}
        <DashboardTopbar
          searchQuery={searchQuery}
          onSearchChange={onSearchChange}
          filterStatus={filterStatus}
          onFilterChange={onFilterChange}
          sortBy={sortBy}
          onSortChange={onSortChange}
          viewMode={viewMode}
          onViewModeChange={onViewModeChange}
          onThemeToggle={onThemeToggle}
        />

        {/* Content Area */}
        <Box
          sx={{
            ...dashboardLayoutStyles.contentArea,
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};
